// extracted by mini-css-extract-plugin
export default {"container":"il-z","disabled":"jl-z","subtotal":"kl-z","legal":"ll-z"};